import { createContext, useContext } from 'react';

/**
 * Studio request decorations injected onto every operation request
 * (Path C Slice 6, write side). The Image Lab shell provides the active
 * `studioId` + a selection-derived `metadata` block; `useOperationMutation`
 * reads this and merges it into each request so studio-typed metadata is
 * validated + persisted server-side — with no per-panel plumbing.
 *
 * Default is empty (no decoration) so operations run unchanged outside a
 * studio context (and in tests).
 */
export interface StudioRequestValue {
  studioId?: string;
  metadata?: Record<string, unknown>;
}

export const StudioRequestContext = createContext<StudioRequestValue>({});

export function useStudioRequest(): StudioRequestValue {
  return useContext(StudioRequestContext);
}
